import(/* webpackMode: "eager" */ "/home/ubuntu/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/campusLegacy/History Image-2.webp");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/website/public/aboutPageImages/campusLegacy/historyimage.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/AboutPageComponents/HistoryOfCec/HeroBanner/HistoryOfCec.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/website/src/components/Common/FooterCard/FooterCard.tsx");
